const polygamy = [
  { label: "Will not consider", value: "Will not consider" },
  { label: "Will consider", value: "Will consider" },
  { label: "May consider", value: "May consider" },
];
export default polygamy;
